import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiErrorHandler } from "../../errors/api-error-handler";
import { AccordionInitialStateType, AccordionTypes } from "../../models/accordion-model";
import AccordionService from "../../services/accordion.service";

const initialState: AccordionInitialStateType = {
  AccordionData: [],
  AccordionScheduleData: [],
  AccordionProfileData: [],
  AccordionLoading: true,
  AccordionError: undefined,
};

export const retrieveAccordionProfile = createAsyncThunk(
  "Accordion/retrieve",
  async (path: string) => {
    const response = await AccordionService.getAccordionService(path)
    return [response.data];
  }
);

const AccordionProfileSlice = createSlice({
  name: "board-of-Editors",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(retrieveAccordionProfile.pending, (state) => {
        state.AccordionLoading = true;
      })
      .addCase(retrieveAccordionProfile.fulfilled, (state, action) => {
        if (action.payload) {
          state.AccordionLoading = false;
          state.AccordionProfileData = action.payload as AccordionTypes[];
        }
      })
      .addCase(retrieveAccordionProfile.rejected, (state, { payload }) => {
        state.AccordionLoading = false;
        state.AccordionError = apiErrorHandler(Number(payload));
      });
  },
});

export const selectAllEntities = (state: { entities: any }) => state.entities;
export default AccordionProfileSlice.reducer;
